// src/components/Statement/StatementTable.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';

const StatementTable = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);



useEffect(() => {
    
    console.log("StatementTable Component Mounted, fetching for ID:", companyId);

    const fetchData = async () => {
      try {
        // 2. Yahan URL check karein
        const res = await api.get(`/statements/company/${companyId}`);
        console.log("API Response:", res.data);
        setData(res.data.data || []);
        setLoading(false);
      } catch (err) {
       
        console.error("API Error Details:", err.response || err.message);
        setLoading(false);
      }
    };

    if (companyId) {
      fetchData();
    } else {
      console.warn("No Company ID provided!");
    }
  }, [companyId]);
  if (loading) return <div>Loading...</div>;

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>No</th>
            <th>Employee Name</th>
            <th>Tour Date</th>
            <th>Action</th>
          </tr>
        </thead>
   

<tbody>
  {data.length > 0 ? (
    data.map((item, index) => (
      <tr key={item.id}>
        <td>{index + 1}</td>
        
      
        <td>
          {item.user ? `${item.user.firstName || ''} ${item.user.lastName || ''}`.trim() : "N/A"}
        </td>
        
        <td>{item.tourDate ? new Date(item.tourDate).toLocaleDateString() : "N/A"}</td>
        <td>{item.tourType || "N/A"}</td>
        <td>
 
<button 
 className="btn btn-primary" 
onClick={() => navigate(`/view-details/${item.id}`)}>
  View Statement
</button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="5" style={{ textAlign: 'center' }}>No statements found.</td>
    </tr>
  )}
</tbody>
      </table>
    </div>
  );
};

export default StatementTable;